<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="component-container">
  <div class="add-margin">
    <div class="list-container">
      <app-scenario-list [scenarioList]="scenarioList$ | async" [selectedScenario]="selectedScenario$ | async"
        [isLoading]="isLoading$ | async" [views]="views$ | async" [statuses]="statuses$ | async"
        [filterString]="filterString" [paginator]="paginator" [selectedStatuses]="selectedStatuses"
        (itemSelected)="setActive($event)" (saveScenario)="saveScenario($event)"></app-scenario-list>
    </div>
  </div>
</div>
